import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ShoppingBag, LogOut, QrCode, Crown } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import { useCart } from "../contexts/CartContext";
import { useRetailCart } from "../contexts/RetailCartContext";

export function Nav() {
  const { user, logout } = useAuth();
  const { count } = useCart();
  const { count: retailCount } = useRetailCart();
  const nav = useNavigate();
  return (
    <nav className="sticky top-0 z-40 bg-[#FFFDF8]/95 backdrop-blur border-b border-[#E5D8C1]" data-testid="nav-root">
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-logo">
          <img src="/logo.png" alt="Alekas Treats" className="h-14 w-auto" />
          <div className="hidden sm:flex flex-col leading-none">
            <span className="font-heading text-xl tracking-wider text-[#1A1A1A]">ALEKAS TREATS</span>
            <span className="text-[10px] tracking-[0.3em] text-[#5C5A56] uppercase">Chamoy candy · 100% Mexican spices</span>
          </div>
        </Link>
        <div className="hidden md:flex items-center gap-7 text-sm uppercase tracking-widest">
          <Link to="/shop" className="hover:text-[#D32F2F]" data-testid="nav-shop">Shop</Link>
          <Link to="/club" className="hover:text-[#D32F2F] flex items-center gap-1" data-testid="nav-club"><Crown size={14} /> Club</Link>
          <Link to="/wholesale" className="hover:text-[#D32F2F]" data-testid="nav-wholesale">Wholesale</Link>
          <Link to="/contact" className="hover:text-[#D32F2F]" data-testid="nav-contact">Contact</Link>
          <Link to="/cart" className="hover:text-[#D32F2F] relative flex items-center gap-1" data-testid="nav-cart">
            <ShoppingBag size={16} />
            {retailCount > 0 && <span className="bg-[#D32F2F] text-white text-[10px] px-1.5 py-0.5 rounded-full font-heading animate-pulse-slow">{retailCount}</span>}
          </Link>
          {user && user.role ? (
            <>
              <Link to="/invite" className="hover:text-[#D32F2F] flex items-center gap-1.5" data-testid="nav-invite"><QrCode size={14} /> Invite</Link>
              <Link to="/portal" className="hover:text-[#D32F2F] flex items-center gap-2" data-testid="nav-portal">
                Portal {count > 0 && <span className="bg-[#D32F2F] text-white text-xs px-2 py-0.5 rounded-full">{count}</span>}
              </Link>
              {user.role === "admin" && <Link to="/admin" className="hover:text-[#D32F2F]" data-testid="nav-admin">Admin</Link>}
              <button onClick={() => { logout(); nav("/"); toast("Signed out"); }} className="flex items-center gap-1 text-[#5C5A56] hover:text-[#D32F2F]" data-testid="nav-logout">
                <LogOut size={16} />
              </button>
            </>
          ) : (
            <Link to="/login" className="bg-[#1A1A1A] text-[#FFFDF8] px-5 py-2.5 uppercase tracking-widest text-xs hover:bg-[#D32F2F] transition-colors" data-testid="nav-login">Buyer Login</Link>
          )}
        </div>
      </div>
    </nav>
  );
}
